import urls from '../engine/urls';

export async function GetSingleJoke() {
    return await GetJSON(urls().GetSingleJoke);
}

async function GetJSON(url) {
    const requestOptions = {
        method: 'GET',
        headers: { Accept: 'application/json' },
    };

    const resp = await fetch(url, requestOptions);
    if (resp.status == '204') {
        return undefined;
    } else {
        return await resp.json();
    }
}
